var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"charts1",staticClass:"sichuan",attrs:{"id":"myMap"}})
}
var staticRenderFns = []

export { render, staticRenderFns }